import UsersContainer from './containers/UsersContainer';

export default UsersContainer;
